<div id="imgtruck" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner ">
        <div class="carousel-item active">
            <img src="/assets/d.header/Foto1.png" class="d-block w-100" alt="...">
            <div class="overlay">
                <div class="container-fluid">
                    <div class="row align-top-titles">
                        <div class="col col-md-6 offset-1 text-left">
                            <div class="tittles">
                                <h1 class="text__tittles">Encuentra las mejores<br> cargas para tu camion</h1>
                                <h3 class="text__tittles--sub">tenemos para ti mas de 300 cargas disponibles para
                                    transportar <br>
                                    en todo el pais !y cada vez se suman mas!</h3><br>
                                <div class="col-md-2">
                                    <mat-card-actions class="actions-card">
                                        <button mat-raised-button color="primary" class="button-width-auto">
                                            Calificar
                                        </button>
                                    </mat-card-actions>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="col-12 col-lg-12 margin-text">
        <h1 class="text__info--details">LoggiApp te conecta con carga disponible de manera<h2 class="text__info--purple">
                segura y transparente, sin intermediarios</h2>
        </h1>
    </div>
</div>
<div class="container">
    <div class=" row">
        <div class="col-lg-6 col-md-6 col-sm-6">
            <img src="/assets/d.header/16613.png" class="img-fluid" alt="Soy expedidor">
        </div>
        <!--section2-->
        <div class="col-lg-6 col-md-6 col-sm-6">
            <div class="row margin-row">
                <div class="col-6 col-lg col-sm text-center images__info">
                    <img class="" src="/assets/d.header/Group.svg" alt="group">
                </div>
                <div class="col-6 text-left">
                    <h2 class=" title-purple">Envia tus cargas a todo el pais</h2>
                    <p>Ingresa toda la informacion de tu carga y recibe varias ofertas de trasnportistas de manera
                        rapida y simple</p>
                </div>
            </div>
            <div class="row margin-row">
                <div class="col-6 col-lg text-center images__info">
                    <img class="" src="/assets/d.header/Group.svg" alt="group">
                </div>
                <div class="col-6 col-lg text-left ">
                    <h2 class="title-purple">Sigue tus envios</h2>
                    <p>Visualiza la trazabilidad de tu envio en tiempo real y conoce todas sus novedades</p>
                </div>
            </div>
            <div class="row margin-row">
                <div class="col-6 col-lg text-center images__info">
                    <img class="" src="/assets/d.header/Group.svg" alt="group">
                </div>
                <div class="col-6 col-lg text-left">
                    <h2 class="title-purple">Administra la informacion</h2>
                    <p>Encuentra toda la informacion de tus cargas y gestiona tus envios actuales y futuros con una sola
                        herramienta </p>
                </div>
            </div>
            <div class="row margin-row">
                <div class="col-6 col-lg text-center images__info">
                    <img class="" src="/assets/d.header/Group.svg" alt="group">
                </div>
                <div class="col-6 col-lg text-left">
                    <h2 class="title-purple">Reduce los costos logisticos</h2>
                    <p>Ahorra dinero en tus envios con la reduccion de fletes sin intermediarios en la cadena</p>
                </div>
            </div>
        </div>
    </div>
</div>